import { render, staticRenderFns } from "./Speech.vue?vue&type=template&id=2737307c"
import script from "./Speech.vue?vue&type=script&lang=js"
export * from "./Speech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports